module.exports = __webpack_public_path__ + "static/media/leio-mclaren-leiomclaren-com-FwdZYz0yc9g-unsplash.76c822e0.jpg";